import { Injectable, inject } from '@angular/core';
import { IMediaUpload, IMediaUploadResponse } from '../interfaces/media-upload.interface';
import { BehaviorSubject, Observable } from 'rxjs';
import { INestedResponse, IResponse } from '../interfaces/response.interface';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
@Injectable({
    providedIn: 'root'
})
export class MediaUploadService {
    private readonly baseUrl = environment.baseUrl;
    private readonly http = inject(HttpClient);
    userProfileSubject = new BehaviorSubject<string>('');
    userProfileSubjectData = this.userProfileSubject.asObservable();
    hasUnreadNotifications = new BehaviorSubject<boolean>(false);
    hasUnreadNotificationsSubjectData = this.hasUnreadNotifications.asObservable();

    uploadMedia(upload_payload: IMediaUpload): Observable<INestedResponse<IMediaUploadResponse>> {
        return this.http.post<INestedResponse<IMediaUploadResponse>>(`${this.baseUrl}/media-upload`, upload_payload);
    }

    updateCoverPhoto(request_payload: { coverPhotoUrl: string }): Observable<IResponse<null>> {
        return this.http.post<IResponse<null>>(`${this.baseUrl}/users/updateCoverPhoto`, request_payload);
    }

    setUserImage(image: string) {
        this.userProfileSubject.next(image);
    }

    deleteMedia(filePath: string): Observable<INestedResponse<null>> {
        return this.http.post<INestedResponse<null>>(`${this.baseUrl}/media-upload/remove`, { filePath });
    }

    setNotificationCount(flag: boolean) {
        this.hasUnreadNotifications.next(flag);
    }
}
